import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BrandService } from 'app/services/models/brand.service';
import { CategoryService } from 'app/services/models/category.service';
import { CompanyService } from 'app/services/models/company.service';
import { CurrencyService } from 'app/services/models/currency.service';
import { KindService } from 'app/services/models/kind.service';
import { ProductVariantDefinitionService } from 'app/services/models/product-variant-definition.service';
import { ProductVariantService } from 'app/services/models/product-variant.service';
import { ProductService } from 'app/services/models/product.service';
import { TaxService } from 'app/services/models/tax.service';
import { TransactionAdditionalFeatureService } from 'app/services/models/transaction-additional-feature.service';
import { UnitTypeService } from 'app/services/models/unit-type.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { ProductVariantDefinitionComponent } from '../product-variant-definition/product-variant-definition.component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-create-product',
  templateUrl: './create-product.component.html',
  styleUrls: ['./create-product.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CreateProductComponent implements OnInit {
  @BlockUI('section-blocks') blockUI: NgBlockUI;
  productForm: FormGroup; // Form için tanımlama
  isProduct: boolean = false; // Varsayılan olarak ürün seçili

  categories: any[] = [];
  currencies: any[] = [];
  unitTypes: any[] = [];
  taxes: any[] = [];
  brands: any[];
  kinds: any[] = [];
  varyants: any[] = [];

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private unitTypeService: UnitTypeService,
    private categoryService: CategoryService,
    private currencyService: CurrencyService,
    private productService: ProductService,
    private toastrService: ToastrService,
    private taxService: TaxService,
    private brandService: BrandService,
    private kindService: KindService,
    private productVariantDefinitionService: ProductVariantDefinitionService,
    private productVariantService: ProductVariantService,
    private modalService:NgbModal) { }

  async ngOnInit() {
    this.productForm = this.fb.group({
      title: ['', Validators.required],
      currencyId: [1],
      categoryId: [null],
      saleTaxId: [null],
      salePrice: [null],
      purchasePrice: [null],
      purchaseSaleTaxId: [null],
      unitTypeId: [1],
      productType: [false],
      brandModalId: [null],
      kindId: [null],
      barcode: [null],
      code: [null],
      selectedVaryants: this.fb.array([]), // Cardlar burada olacak
      selectedVariantItems: [[]]           // ng-select için seçilenler
    });
    await this.getAllCategories()
    await this.getAllUnitTypes();
    await this.getAllTax();
    await this.getAllCurrencies();
    await this.getAllBrand();
    await this.getAllKinds();
    await this.getVaryants();

  }

  async getAllKinds() {
    const data = await this.kindService.getAllKinds('', 0, 100, 13);
    this.kinds = data.types;
  }

  // Ürün Tipi Değiştiğinde Çağrılacak Fonksiyon
  onProductTypeChange(isProduct: boolean) {
    this.isProduct = isProduct;
    if (!isProduct) {
      // Eğer hizmet seçildiyse gereksiz alanları temizle
      this.productForm.patchValue({
        unitTypeId: null,
        purchaseSaleTaxId: null,
        purchasePrice: null
      });
    }
  }

  async getAllBrand() {
    const data = await this.brandService.getBrands();
    // flatMap kullanarak tek katmanlı bir dizi oluşturuyoruz
    this.brands = data.flatMap(brand =>
      brand.brandModels.map(model => ({
        id: model.id,                // Modelin ID'sini ekliyoruz
        name: model.modelName,        // Model ismi
        brandName: brand.brandName    // Grup başlığı olarak marka ismi
      }))
    );
    console.log(this.brands);
  }

  async getAllTax() {
    const tax = await this.taxService.getAllTax(0, 100, '');
    console.log(tax);
    this.taxes = tax.taxex;
  }

  async getAllUnitTypes() {
    const unitType = await this.unitTypeService.getAllUnitType(0, 100, '');
    this.unitTypes = unitType.unitTypes;
    console.log(this.unitTypes);
  }

  async getAllCurrencies() {
    const currency = await this.currencyService.getAllPageCurrency(0, 100, '');
    this.currencies = currency.currenies;
    console.log(this.currencies);
  }

  async getAllCategories() {
    const category = await this.categoryService.getAllCategory(0, 100, '', 1);
    this.categories = category.categories;
    console.log(this.categories);
  }

  async getVaryants() {
    const data = await this.productVariantDefinitionService.getAllProductVariantDefinition();
    console.log(data);
    this.varyants = data;
  }

  get selectedVaryants(): FormArray {
    return this.productForm.get('selectedVaryants') as FormArray;
  }

  get selectedVariantItems(): any[] {
    return this.productForm.get('selectedVariantItems')?.value || [];
  }

  removeVariant(index: number) {
    this.selectedVaryants.removeAt(index);
  }

  addVariant(variant: any) {
    const isOptionType = variant.variantType === 1;
    const isTrueFalseType = variant.variantType === 2;


    const variantGroup = this.fb.group({
      id: [variant.id],
      name: [variant.name],
      secondName: [variant.secondName],
      variantType: [variant.variantType],
      isRequired: [false],
      displayOrder: [this.selectedVaryants.length + 1],
      trueLabel: [
        isTrueFalseType ? (variant.trueLabel || 'Evet') : '',
        isTrueFalseType ? Validators.required : null // <-- Zorunluluk eklendi
      ],
      falseLabel: [
        isTrueFalseType ? (variant.falseLabel || 'Hayır') : '',
        isTrueFalseType ? Validators.required : null // <-- Zorunluluk eklendi
      ],
      // Eğer gelen varyantta options varsa yükle
      options: this.fb.array(
        (variant.options || []).map((opt: any) => this.createOptionGroup(opt))
      )
    }, { validators: isOptionType ? this.variantGroupValidator : null });

    this.selectedVaryants.push(variantGroup);
  }

  variantGroupValidator = (group: FormGroup): { [key: string]: any } | null => {
    const variantType = group.get('variantType')?.value;

    // Kural 1: Option Tipi (1) en az 1 seçenek (options) gerektirir.
    if (variantType === 1) {
      const optionsArray = group.get('options') as FormArray;
      if (!optionsArray || optionsArray.length === 0) {
        return { requiresOptions: true };
      }
    }

    // Kural 2: True/False Tipi (2) için trueLabel ve falseLabel'in zorunluluğu, 
    // aşağıdaki addVariant/onVariantChange metotlarında kontrol bazında ayarlanmıştır.

    return null;
  }

  async getProductVaryantValues(id: number) {
    console.log('%c📡 getProductVaryantValues çağrıldı:', 'color: cyan;', id);
    try {
      const data = await this.productVariantService.getProductVaryantValues(id);
      console.log('%c✅ API cevabı:', 'color: lightgreen;', data);
      return data;
    } catch (err) {
      console.error('%c❌ API hatası:', 'color: red;', err);
      return [];
    }
  }

  varyantCache = new Map<number, any[]>();

  async onVariantChange() {
    console.log('%c🎯 onVariantChange tetiklendi', 'color: yellow;');
    console.log('%cSeçilen varyantlar:', 'color: lightblue;', this.selectedVariantItems);

    const formArray = this.selectedVaryants;

    for (const item of this.selectedVariantItems) {
      console.log('%c🧩 Varyant işleniyor:', 'color: orange;', item);

      const alreadyExists = formArray.controls.some(
        ctrl => ctrl.get('id')?.value === item.id
      );

      if (alreadyExists) {
        console.log(`⚠️ ${item.name} zaten formda var, atlanıyor`);
        continue;
      }

      // Türleri normalize et (string => number)
      const type = +item.variantType;
      const isOptionType = type === 1;
      const isTrueFalseType = type === 2;
      const isAutoType = type === 1;

      console.log(`📌 ${item.name} tipi: ${type} | Otomatik mi? ${isAutoType}`);

      const variantGroup = this.fb.group({
        id: [item.id],
        name: [item.name],
        secondName: [item.secondName],
        variantType: [type],
        isRequired: [false],
        displayOrder: [formArray.length + 1],
        trueLabel: [
          null,
          isTrueFalseType ? Validators.required : null
        ],
        falseLabel: [
          null,
          isTrueFalseType ? Validators.required : null
        ],
        options: this.fb.array([])
      }, { validators: isOptionType ? this.variantGroupValidator : null });

      formArray.push(variantGroup);

      // 🔹 Eğer otomatik varyantsa değerleri getir
      if (isAutoType) {
        console.log(`🚀 ${item.name} için otomatik değerler getiriliyor...`);
        try {
          let data;

          if (this.varyantCache.has(item.id)) {
            console.log('💾 Cache kullanılıyor');
            data = this.varyantCache.get(item.id);
          } else {
            console.log('🌐 API’den çekiliyor');
            data = await this.getProductVaryantValues(item.id);
            this.varyantCache.set(item.id, data);
          }

          const optionsArray = variantGroup.get('options') as FormArray;

          if (data && Array.isArray(data) && data.length) {
            console.log(`✅ ${data.length} adet değer bulundu`);
            data.forEach((opt: any) => {
              optionsArray.push(
                this.fb.group({
                  name: [opt.optionValue || opt.name || '']
                })
              );
            });
          } else {
            console.warn(`⚠️ ${item.name} için değer bulunamadı veya boş döndü`);
          }
        } catch (err) {
          console.error(`❌ ${item.name} için değer alınamadı:`, err);
        }
      }
    }

    // 🔻 Artık seçili olmayanları kaldır
    for (let i = formArray.length - 1; i >= 0; i--) {
      const id = formArray.at(i).get('id')?.value;
      const stillSelected = this.selectedVariantItems.some(item => item.id === id);
      if (!stillSelected) {
        console.log(`🗑️ ${id} kaldırılıyor (artık seçili değil)`);
        formArray.removeAt(i);
      }
    }

    console.log('%c✅ Güncel formArray:', 'color: lightgreen;', formArray.value);
  }


  private createOptionGroup(option: any) {
    return this.fb.group({
      name: [option.name || ''],
      value: [option.value || ''],
      displayOrder: [option.displayOrder || 1]
    });
  }

  getOptions(variantIndex: number): FormArray {
    return this.selectedVaryants.at(variantIndex).get('options') as FormArray;
  }

  addOption(variantIndex: number) {
    const options = this.getOptions(variantIndex);
    options.push(this.fb.group({
      name: [null],
      value: [null],
      displayOrder: [options.length + 1]
    }));
  }

  removeOption(variantIndex: number, optionIndex: number) {
    this.getOptions(variantIndex).removeAt(optionIndex);
  }

  dropVariant(event: CdkDragDrop<FormGroup[]>) {
    console.log('Variant dropped:', event);
    moveItemInArray(this.selectedVaryants.controls, event.previousIndex, event.currentIndex);

    // **İyileştirme:** Re-indexing yaparken emitEvent: false kullanılarak performans artırılır
    this.selectedVaryants.controls.forEach((v, i) => v.get('displayOrder')?.setValue(i + 1, { emitEvent: false }));
  }

  // Değişiklikler burada yapıldı
  dropOption(variantIndex: number, event: CdkDragDrop<FormGroup[]>) {
    const options = this.getOptions(variantIndex).controls;
    moveItemInArray(options, event.previousIndex, event.currentIndex);

    // **İyileştirme:** Re-indexing yaparken emitEvent: false kullanılarak performans artırılır
    options.forEach((o, i) => o.get('displayOrder')?.setValue(i + 1, { emitEvent: false }));
  }

  showCreateVariant() {
    const modal = this.modalService.open(ProductVariantDefinitionComponent,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static'
      }
    );
    modal.componentInstance.id = null;
    modal.result.then(async (res) => {
      console.log(res);
      if (res == true) {
        await this.getVaryants();
      }
    });
  }

  confirmClearOptions(index: number) {
    const variantName = this.selectedVaryants.at(index).get('name')?.value || 'Bu varyant';
    const modal = this.modalService.open(ConfirmDialogComponent, {
      centered: true,
      backdrop: 'static'
    });
    modal.componentInstance.data = {
      title: 'Varyant Seçenekleri Silme',
      message: `${variantName} için tüm seçenekleri silmek istediğinize emin misiniz?`,
    };
    modal.result.then((res) => {
      if (res == true) {
        const optionsArray = this.getOptions(index);
        if (optionsArray) {
          while (optionsArray.length > 0) {
            optionsArray.removeAt(0);
          }
        }
      }
    });
  }

  closeModal() {
    this.activeModal.close(false);
  }

  async onSubmit() {
    this.blockUI.start("ürün ekleniyor...");
    if (this.productForm.valid) {
      console.log(this.productForm.value);
      const createProductVaryantDtos = this.productForm.value.selectedVaryants.map(
        (variant: any) => ({
          // Angular'daki 'id' backend'de 'ProductVariantDefinitionId' olarak gönderiliyor
          productVariantDefinitionId: variant.id,
          // Diğer alanlar birebir eşleşiyor
          isRequired: variant.isRequired,
          displayOrder: variant.displayOrder,
          isActive: true, // Varsayılan olarak true gönderiliyor
          trueLabel: variant.trueLabel,
          falseLabel: variant.falseLabel,
          // Angular'daki 'options' backend'de 'CreateProductVariantOptionDTOs' olarak gönderiliyor
          createProductVariantOptionDTOs: variant.options.map(
            (option: any) => ({
              // Option içindeki alanlar birebir eşleşiyor
              name: option.name,
              value: option.value,
              displayOrder: option.displayOrder
            })
          )
        })
      );
      const response = await this.productService.createProduct({
        name: this.productForm.value.title,
        saleTaxId: this.productForm.value.saleTaxId,
        salePrice: this.productForm.value.salePrice,
        categoryId: this.productForm.value.categoryId,
        currencyId: this.productForm.value.currencyId,
        unitTypeId: this.productForm.value.unitTypeId,
        warehouseId: 1,
        productCount: 0,
        productType: this.productForm.value.productType,
        purchaseTaxId: this.productForm.value.purchaseTaxId,
        purchasePrice: this.productForm.value.purchasePrice,
        brandModalId: this.productForm.value.brandModalId,
        kindId: this.productForm.value.kindId,
        barcode: this.productForm.value.barcode,
        code: this.productForm.value.code,
        createProductVaryantDtos:createProductVaryantDtos
      });
      if (response.status) {
        this.blockUI.stop();
        this.productService.sendEvent(true);
        this.closeModal();
        this.toastrService.success(response.message);
      } else {
        this.blockUI.stop();
        this.toastrService.error(response.message);
      }
    }
  }
}